/** SA-1060 (spec 2026-10-09 §2.5): the count line and Expand all / Collapse
 * all at the top of the Steps tab in both editors. Acts on the CARDS the
 * caller names, never on the in-step disclosures. */
import { Button } from '@/components/ui'

export function ProcessEditorToolbar({
  line,
  onExpandAll,
  onCollapseAll,
}: {
  line: string
  onExpandAll: () => void
  onCollapseAll: () => void
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p data-testid="process-editor-count" className="text-xs text-muted-foreground">
        {line}
      </p>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="ghost" onClick={onExpandAll}>
          Expand all
        </Button>
        <Button size="sm" variant="ghost" onClick={onCollapseAll}>
          Collapse all
        </Button>
      </div>
    </div>
  )
}
